export default {
    //Token
    saveToken({commit},payload){
        commit('saveToken',payload)
    },

}



// WEBPACK FOOTER //
// ./src/store/actions.js